import ResendEmailsModal from './ResendEmailsModal.component'

export default ResendEmailsModal
